import currencyCodes from 'currency-codes';

export const FinanceCurrencyCodes = currencyCodes.codes().map(code => {
  let key = code;
  let value = currencyCodes.code(code).currency;
  return {
    key,
    value
  };
});

export const FinanceTypes = {
  directDebits: {
    id: 'directDebits',
    type: 'directDebit',
    tabIndex: 0,
    docDescription: 'SEPA_DIRECT_DEBITS'
  },
  receivedPayments: {
    id: 'receivedPayments',
    type: 'receivedPayment',
    tabIndex: 1,
    docDescription: 'RECEIVED_PAYMENTS'
  },
  standingOrders: {
    id: 'standingOrders',
    type: 'standingOrder',
    tabIndex: 2,
    docDescription: 'STANDING_ORDERS'
  }
};

export const FinanceSequencyTypes = [
  {
    key: 'OOFF',
    value: 'app.finances.sequences.ooff'
  },
  {
    key: 'RCUR',
    value: 'app.finances.sequences.rcur'
  },
  {
    key: 'FRST',
    value: 'app.finances.sequences.frst'
  },
  {
    key: 'FNAL',
    value: 'app.finances.sequences.fnal'
  }
];

export const FinanceIntervalTypes = [
  {
    key: 'weekly',
    value: 'app.finances.interval.weekly'
  },
  {
    key: 'monthly',
    value: 'app.finances.interval.monthly'
  },
  {
    key: 'bi_monthly',
    value: 'app.finances.interval.bi_monthly'
  },
  {
    key: 'quarterly',
    value: 'app.finances.interval.quarterly'
  },
  {
    key: 'triannual',
    value: 'app.finances.interval.triannual'
  },
  {
    key: 'half_yearly',
    value: 'app.finances.interval.half_yearly'
  },
  {
    key: 'yearly',
    value: 'app.finances.interval.yearly'
  },
  {
    key: 'variable',
    value: 'app.finances.interval.variable'
  }
];

export const FinanceTypeDocuments = Object.keys(FinanceTypes).reduce((type, key) => {
  type[FinanceTypes[key].docDescription] = key;
  return type;
}, {});

export const FinanceDirectDebitProperties = [
  'creditorId',
  'mref',
  'purpose'
];

export const FinanceReceivedPaymentProperties = [
  'purpose'
];

export const FinanceStandingOrdersProperties = [
  'amount',
  'iban',
  'interval',
  'nextExecution'
];
